import GraphQLSolutionDAOFactory from "../../../solution/majorVersion/dao/GraphQLSolutionDAOFactory";
import SolutionDAO from "../../../solution/majorVersion/dao/SolutionDAO";
import { useSnackbar } from "notistack";

const solutionRecordDAO: SolutionDAO = GraphQLSolutionDAOFactory.getInstance();

export const useArchiveSolution = () => {
    const snackbar = useSnackbar();

    const archiveSolution = async (solutionId: string) => {
        try {
            await solutionRecordDAO.archive(solutionId);
        } catch (error) {
            console.error(`Failed to archive solution ${solutionId}: `, error);
            snackbar.enqueueSnackbar("Failed to archive the solution, please try again later", { variant: "error" });
        }
    };

    return { archiveSolution };
};